<template>
	<div :class="{ 'list': true, 'list--loading': loading }">
		<!-- Hide table entirely if set to only "new" madds and no results -->
		<Vuetable
            ref="vuetable"
            api-url="madds"
            pagination-path="meta"
            :fields="fields"
            :css="css"
            @vuetable:pagination-data="onPaginationData"
            @vuetable:loading="onLoading"
            @vuetable:loaded="onLoaded"
            @vuetable-load-error="onLoadError"
            :http-fetch="fetch"
            :load-on-start="loadOnStart"
            :append-params="filters"
            :row-class="onRowClass"
            :min-rows="loading ? 10 : null"
            :no-data-template="loaded && !newOnly ? 'No MADDs found' : ''"
		/>

		<!-- Error while loading -->
		<div class="list__error" v-if="error">
			<span class="h2">Unable to load MADDs.</span>
			<button class="btn btn--link" @click.prevent="load">Retry</button>
		</div>

		<!-- Showing only "new" madds and no results -->
		<div class="list__empty" v-if="newOnly && empty">
			<span class="h2">You're all up to date!</span>
			<router-link to="/madds" class="btn btn--link">View all MADDs</router-link>
		</div>

		<Pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></Pagination>
	</div>
</template>

<script>
	import Vue from 'vue';
	import Vuetable from 'vuetable-2/src/components/Vuetable';
	import ColumnMADD from './ColumnMADD';
	import ColumnSector from './ColumnSector';
	import ColumnCreated from './ColumnCreated';
	import ColumnCompletedAt from './ColumnCompletedAt';
	import Pagination from './Pagination';
	import FilterableList from './FilterableList';

	Vue.component('column-madd', ColumnMADD);
	Vue.component('column-sectors', ColumnSector);
	Vue.component('column-created', ColumnCreated);
	Vue.component('column-completed-at', ColumnCompletedAt);


	export default {
		name: 'ListMADDs',
		mixins: [FilterableList],
		components: {
			Pagination,
			Vuetable,
		},
        methods: {
            resetPagination() {
                this.$refs.vuetable.changePage(1)
            },
        },
		data() {
			return {
				loaded: false,
				fields: [
					{
						name: '__component:column-madd',
						sortField: 'company_name',
						title: 'MADD',
					},
					{
						name: 'dealType',
						sortField: 'deal_type',
						title: 'Deal Type',
						width: '150px',
						dataClass: 'data-label deal-type'
					},
					{
						name: 'dealValue',
						sortField: 'transaction_value',
						title: 'Value',
						width: '100px',
						dataClass: 'data-label transaction-value'
					},
					{
						name: '__component:column-sectors',
						title: 'Main Sector',
						width: '300px',
						dataClass: 'data-sector'
					},
					{
						name: '__component:column-completed-at',
						sortField: 'completed_at',
						title: 'Completed',
						titleClass: 'right',
						width: '100px',
						dataClass: 'data-label created-at'
					}
				]
			};
		},
	}
</script>
